import { useTranslation } from 'react-i18next'
import { PublicPageControls } from '@/components/app/PublicPageControls'
import { StateSurface } from '@/components/app/StateSurface'

export function NotFoundPage() {
  const { t } = useTranslation()

  return (
    <div className="relative">
      <div className="absolute right-4 top-4 z-20 sm:right-6 sm:top-6">
        <PublicPageControls />
      </div>
      <StateSurface
        variant="fullscreen"
        size="lg"
        tone="info"
        asset={
          <img
            src="/Uploads/page_not_found.webp"
            alt={t('system.notFound.title')}
            className="h-56 w-56 md:h-64 md:w-64 object-contain"
          />
        }
        title={t('system.notFound.title')}
        description={t('system.notFound.description')}
        primaryAction={{
          label: t('system.notFound.openDashboard'),
          to: '/dashboard',
        }}
        secondaryAction={{
          label: t('system.notFound.openLogin'),
          to: '/login',
        }}
      />
    </div>
  )
}
